import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

const COMMENT_MAX_LENGTH = 1000;

const renderTextField = ({ input, meta, ...custom }) => (
    <TextField
        {...input}
        {...custom}
        variant="standard"
        fullWidth
        inputProps={{ maxLength: COMMENT_MAX_LENGTH }}
        helperText={input.value.length > COMMENT_MAX_LENGTH - 100 ? `${input.value.length} / ${COMMENT_MAX_LENGTH}` : ''}
        sx={{ minWidth: '360px' }}
    />
);

export default ({ code, id }) => {
    const { t } = useTranslation();
    return (
        <Field
            name={JSON.stringify({ code, id })}
            placeholder={t('promoVisits.commentPlaceholder')}
            component={renderTextField}
            type="text"
        />
    );
};
